import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';

import { HOME, DEVICE_ACTIVATION } from '../../routes';
import fetchRequest from '../../utils/fetchRequest';
import {
  getHasNotActivatedSub,
  getSession,
  setSession,
} from '../../utils/session';
import RequestCodeForm from './RequestCodeForm';
import CodeVerificationForm from './CodeVerificationForm';
import LayoutWithBg from '../../components/layout/LayoutWithBg';
import * as routes from '../../routes';
import { GOOGLE_RECAPTCHA_V2_CLIENT } from '../../configs';
import VerizonBanner from '../../components/common/features/VerizonBanner';
// import { hasWhitelistedDevice } from '../../utils/temp-login';

const Login = () => {
  const session = getSession();
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const recaptchaRef = useRef();

  const [error, setError] = useState(null);
  const [email, setEmail] = useState(null);
  const [sessionToken, setSessionToken] = useState('');
  const [codeIsSent, setCodeIsSent] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const backToEmail = () => {
    setCodeIsSent(false);
    setError('');
  };

  const handleRequestCodeForm = async (data) => {
    try {
      setLoading(true);
      const response = await fetchRequest.post('/auth/request_login_code', {
        email: data.email,
        recaptcha_client_token: data?.recaptchaToken,
      });
      const { session_token } = response.data;
      if (session_token) {
        setSessionToken(session_token);
      }
      setError(null);
      setCodeIsSent(true);
    } catch (e) {
      if (!navigator.onLine) {
        setError('Network error. Please, check your connection');
      } else {
        setError(null);
        setCodeIsSent(true);
      }
    } finally {
      setLoading(false);
      setEmail(data.email);
    }
  };

  const handleCodeVerification = async (code) => {
    try {
      const response = await fetchRequest.post('/auth/verify_login_code', {
        email: email,
        session_token: sessionToken,
        code: code,
      });

      setSession(response?.data);
      // whitelist
      // const subsResponse = await dispatch(
      //   subscriptionsApi.endpoints.getListSubscriptions.initiate(),
      //   { track: false },
      // );
      // const subs = subsResponse?.data?.subscriptions;
      // const isWhitelisted = hasWhitelistedDevice(subs);
      // setSession(response?.data, isWhitelisted);

      if (response?.data?.hasNotActivatedSub) {
        const currentSearchParams = new URLSearchParams(window.location.search);
        return navigate(
          `${DEVICE_ACTIVATION}?${currentSearchParams.toString()}`,
        );
      } else {
        return navigate(HOME);
        // whitelist
        // const currentSearchParams = new URLSearchParams(window.location.search);
        // if (isWhitelisted) {
        //   return navigate(HOME);
        // } else {
        //   window.location = `${OLD_DASH_URL}/?${currentSearchParams.toString()}`;
        //   return;
        // }
      }
    } catch (e) {
      if (!navigator.onLine) {
        setError('Network error. Please, check your connection');
      } else {
        setError(
          `Hmm… looks like the code you entered was incorrect. If you haven't received a code, please double check entered email`,
        );
      }
    }
  };
  const handleResendCodeVerification = async () => {
    try {
      setLoading(true);
      const response = await fetchRequest.post('/auth/regenerate_login_code', {
        email,
      });
      const { session_token } = response.data;
      setSessionToken(session_token);
    } catch (e) {
      if (!navigator.onLine) {
        setError('Network error. Please, check your connection');
      }
    } finally {
      setLoading(false);
      setError(null);
      setCodeIsSent(true);
    }
  };

  useEffect(() => {
    if (session) {
      const hasNotActivatedSubs = getHasNotActivatedSub();
      if (hasNotActivatedSubs) {
        const currentSearchParams = new URLSearchParams(window.location.search);
        return navigate(
          `${routes.DEVICE_ACTIVATION}?${currentSearchParams.toString()}`,
        );
      } else if (!searchParams.get('email')) {
        return navigate(HOME);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LayoutWithBg>
      <VerizonBanner />
      {!codeIsSent ? (
        <RequestCodeForm
          formHandler={handleRequestCodeForm}
          isLoading={isLoading}
          error={error}
          email={email}
          recaptchaRef={recaptchaRef}
        />
      ) : (
        <CodeVerificationForm
          isLoading={isLoading}
          formHandler={handleCodeVerification}
          resendHandler={handleResendCodeVerification}
          backToEmail={backToEmail}
          error={error}
        />
      )}
      {!window?.Cypress && (
        <ReCAPTCHA
          ref={recaptchaRef}
          badge="bottomleft"
          size="invisible"
          sitekey={GOOGLE_RECAPTCHA_V2_CLIENT}
        />
      )}
    </LayoutWithBg>
  );
};

export default Login;
